/*********************** Custom JS for Boost AI Search & Discovery  ************************/
let totalSearchResults = 0;

function getWindowLocation() {
    // Escape window.location.href
    var href = window.location.href;
    var escapedHref = href.replace(/%3C/g, '&lt;').replace(/%3E/g, '&gt;');

    // Rebuild window.location.href
    var rebuildHrefArr = [];
    for (var i = 0; i < escapedHref.length; i++) {
        rebuildHrefArr.push(escapedHref.charAt(i));
    }
    var rebuildHref = rebuildHrefArr.join('').split('&lt;').join('%3C').split('&gt;').join('%3E');

    // Rebuild window.location.search
    var rebuildSearch = "";
    var hrefWithoutHash = rebuildHref.replace(/#.*$/, '');
    if (hrefWithoutHash.split('?').length > 1) {
        rebuildSearch = hrefWithoutHash.split('?')[1];
        if (rebuildSearch.length > 0) {
            rebuildSearch = '?' + rebuildSearch;
        }
    }

    return {
        pathname: window.location.pathname,
        href: rebuildHref,
        search: rebuildSearch
    }
}

function isSearchPage() {
    // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/search?xxx
    // Google cache URL
    if (getWindowLocation().href.includes('webcache.googleusercontent.com')) {
        return getWindowLocation().search.indexOf('search?') > -1;

        // Normal URL
    } else {
        return window.location.pathname.indexOf('/search') > -1;
    }
};

const customize = {
    searchApi: (componentRegistry) => {
        componentRegistry.useModulePlugin('SearchAPI', {
            name: 'Extra data SearchAPI',
            apply(builder) {
                builder.on('methodFulfilled', 'searchInCollection', (data) => {
                    // TODO
                    try {
                        if (data?.result?.total_product) totalSearchResults = data.result.total_product;
                    } catch (error) {
                        console.warn(error);
                    }
                    // END TODO
                });
            },
        });
    },
    addProductCount: (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductList", {
            name: "add product count - Boost-221860",
            enabled: true,
            apply: () => ({
                props: (props) => {
                    return props;
                },
                afterRender(element) {
                    try {
                        const productList = element.getRootElm();

                        const breadcrumbElm = document.querySelector('.breadcrumb .container');
                        if (isSearchPage() && breadcrumbElm) {
                            const newText = '<a href="/" title="Home">Home</a> <span aria-hidden="true">/</span><span>Search: ' + totalSearchResults + ' ' + (totalSearchResults > 1 ? ' results' : ' result') + ' found</span>';
                            breadcrumbElm.innerHTML = newText;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                },
            }),
        });
    },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.searchApi,
    customize.addProductCount,
]);